<template>
    <div>

        <edit-production-contract-dialog
            v-model="show_dialog"
            :model_prop="record_to_modify"
            :constants="constants"
            :valuelists="valuelists"
            @successful-save="$refs.production_contracts_list.refreshList()"
            @successful-delete="$refs.production_contracts_list.refreshList()"
        />

        <div class="tw-flex tw-flex-row tw-gap-6 tw-p-1">
                <v-btn @click="addRecord" class="main-btn">Add Contract</v-btn>
        </div>

        <div>
            <smart-table
                ref="production_contracts_list"
                endpoint="productioncontract.list"
                :headers="headers"
                @click:row="editRecord"
            >
                <template v-slot:item.status="{ isMobile, item, header, value, index}">
                    {{ getStatus(item) }}
                </template>
                <template v-slot:item.contract_id="{ isMobile, item, header, value, index}">
                    {{ getContractType(item) }}
                </template>

            </smart-table>
        </div>

    </div>

</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import DatePicker from "@/Generic/DatePicker";
    import EditProductionContractDialog from "@/Modals/EditProductionContractDialog.vue";

    export default {
        name: "ProductionsManageContracts",
        components: {
            EditProductionContractDialog,
            SmartTable,
            InternalHeader,
            DatePicker,
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'is_edit_prop': {
                type: Boolean,
                required:false,
                default: function() {
                    return false
                }
            },
        },
        data() {
            return {
                production: this.input || {},
                constant: this.constants,
                valuelist: this.valuelists,
                show_dialog: false,
                save_loading: false,
                archive_loading: false,
                is_edit: this.is_edit_prop,
                record_to_modify: null,
                rules: {
                    required: value => !!value || 'Required',
                },
                errors: null,
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'name',             text: 'Name',           align: `start`,     sortable: true,     filterable: false,   },
                    {value: 'file',             text: 'File Name',      align: `start`,     sortable: true,     filterable: false,   },
                    {value: 'status',           text: 'Status',         align: `start`,     sortable: true,     filterable: false,   },
                    {value: 'contract_id',      text: 'Type',           align: `start`,     sortable: true,     filterable: false,   },
                    {value: 'production_id',    text: 'Type',           align: ` d-none`,   sortable: true,     filterable: true,  search: this.production?.id  },
                ]
            },
            is_user_admin() {
                return this.$root.getUserRole() === this.constants?.USER_ROLES?.ROLE_ADMIN
            },
        },
        methods: {
            addRecord() {
                this.record_to_modify = null
                this.show_dialog = true
            },
            editRecord(record) {
                this.record_to_modify = record
                this.show_dialog = true
            },
            getStatus(production_contract) {
                return this.valuelists?.CONTRACT_STATUSES?.find(contract => contract.value === production_contract.status)?.text
            },
            getContractType(production_contract) {
                return this.valuelists?.CONTRACTS?.find(contract => contract.value === production_contract.contract_id)?.text
            },
            saveDetails() {
                if (this.$refs.manageDetailsForm.validate()) {
                    let formData = this.production

                    var url = ''
                    var method = ''

                    if(this.is_edit) {
                        url = route('productions.update', this.production.id)
                        method = 'put'
                    } else {
                        url = route('productions.store')
                        method = 'post'
                    }

                    axios({
                        method: method,
                        url: url,
                        data: formData,
                        onUploadProgress: (evt) => {
                            this.save_loading = !this.save_loading
                        },
                        onDownloadProgress: (evt) => {
                            this.save_loading = !this.save_loading
                        },
                    })
                        .then(response =>
                        {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success('Changes have been saved')
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.save_loading = false
                                this.$emit('successful-manage-production-save')

                                if (!this.is_edit) {
                                    this.$inertia.visit(route('productions.edit', response.data.data.id))
                                }
                            } else if( response.data?.error ) {
                                throw (response.data?.error)
                            } else {
                                throw ('Unknow error.')
                            }
                        })
                        .catch((error) => {
                            if( error?.response ) {
                                this.$root.snackbar.error(error.response.data.message)
                                this.errors = error.response?.data?.errors
                            } else {
                                console.log(error)
                                this.$root.snackbar.error(error)
                            }
                            this.save_loading = false
                        })
                } else {
                    this.$root.snackbar.error('Please fill all required fields.')
                }
            },
            async archiveProduction()
            {
                if (await this.$root.confirm.open(`Delete Production`, `You are about to delete ${this.production.name}  #${this.production.id}`)) {

                    let method = 'delete'
                    let url = route('productions.destroy', this.production.id)
                    let payload = this.member

                    axios({
                        method: method,
                        url: url,
                        data: payload,
                        onUploadProgress: (evt) => {
                            this.archive_loading = !this.archive_loading
                        },
                        onDownloadProgress: (evt) => {
                            this.archive_loading = !this.archive_loading
                        },
                    })
                        .then(response => {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success('Production has been deleted')
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.archive_loading = false
                                this.$emit('successful-production-delete')

                                this.$inertia.visit(route('productions.index'))
                            } else {
                                throw (response.data.error)
                            }
                        })
                        .catch((error) => {
                            this.$root.snackbar.error(error.response.data.message)
                            this.archive_loading = false
                        })
                }
            },
        },
        watch: {
            input(newInput, oldInput) {
                this.production = newInput
            },
            saveLoading(newValue, oldValue) {
                this.$emit('save-loading-change', newValue)
            }
        }
    }
</script>
<style scoped>

.section > .v-input{
    flex-grow: 0;
}

</style>
